import { render, staticRenderFns } from "./process-record.vue?vue&type=template&id=5074dad2&scoped=true&"
import script from "./process-record.vue?vue&type=script&lang=js&"
export * from "./process-record.vue?vue&type=script&lang=js&"
import style0 from "./process-record.vue?vue&type=style&index=0&id=5074dad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5074dad2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\webproject\\haoyu\\wms-web\\WMS\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5074dad2')) {
      api.createRecord('5074dad2', component.options)
    } else {
      api.reload('5074dad2', component.options)
    }
    module.hot.accept("./process-record.vue?vue&type=template&id=5074dad2&scoped=true&", function () {
      api.rerender('5074dad2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mes/components/productionProgress/process-record.vue"
export default component.exports